import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import { api } from './services/config'

import BootstrapVue from 'bootstrap-vue'
import VueHead from 'vue-head'
import VueCarousel from 'vue-carousel'
import VueGraph from 'vue-graph'
import VueApexCharts from 'vue-apexcharts'
import JsonCSV from 'vue-json-csv'
import VueJwtDecode from 'vue-jwt-decode'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueTheMask from 'vue-the-mask'
import JsonExcel from 'vue-json-excel'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueAppleSignin from 'vue-apple-signin'
import VueGtag from 'vue-gtag'

import '@/mixins/helper'
import '@/mixins/apiHelper'

Vue.component('v-select', vSelect)

Vue.component('downloadCsv', JsonCSV)
Vue.use(VueJwtDecode)
Vue.use(VueApexCharts)
Vue.use(HighchartsVue.default)
Vue.use(VueTheMask)
Vue.use(VueTelInput)
Vue.component('downloadExcel', JsonExcel)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-115628282-10',
})

Vue.use(VueGraph)
Vue.use(BootstrapVue)
Vue.use(VueHead)
Vue.use(VueCarousel)

Vue.use(VueAppleSignin, {
  clientId: process.env.VUE_APP_CLIENT_ID,
  scope: 'name email',
  redirectURI: `${api}/api/v1/auth/apple-callback`,
  state: '2023-10-11',
  usePopup: true,
})

Vue.use(
  VueGtag,
  {
    config: {
      id: ['G-NHJ8EV919N'], // ganti dengan ID GA4 Anda
      params: {
        send_page_view: false,
      },
    },
  },
  router
)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
